import { useAuthenticateFunnelApiV1FunnelPostMutation } from "@/store/baseClientApi";
import { ensureError, localizeError } from "@/utils/helpers";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const CodeKey = "funnel-code";

export const FunnelAuthenticator = () => {
  const { t } = useTranslation();
  const [authenticate] = useAuthenticateFunnelApiV1FunnelPostMutation();

  useEffect(() => {
    const code = localStorage.getItem(CodeKey);

    const startAuthentication = async () => {
      if (code == null) {
        return;
      }

      try {
        await authenticate({
          authenticateFunnelRequest: {
            code: code
          }
        }).unwrap();
      } catch (err) {
        const error = ensureError(err);
        toast.error(localizeError(t, error));
      }

      localStorage.removeItem(CodeKey);
    };

    startAuthentication();
  }, [authenticate]); // eslint-disable-line react-hooks/exhaustive-deps
  return <></>;
};
